import { forwardRef, useImperativeHandle, useState } from "react"
import { Modal, Box } from "@mui/material"
import styles from "../Modals.module.css"
import ModalCloseButton from "../ModalCloseButton"
import AddItemForm from "../../Marketplace/AddItemForm"
import { useApiService } from "../../hooks/Api/useApiService"
import useError from "../../hooks/Error/useError"

const AddMarketItemModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const [open, setOpen] = useState(false)
  const { postData } = useApiService()
  const { Error: AlertError, error, success } = useError()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleAddItem = async (item) => {
    postData("sharie/addmarketitem", { user_name: localStorage.getItem("user"), ...item }).then(
      (data) => {
        if (data?.message === "success") {
          success("Added Successfully!")
          handleClose()
        } else {
          // Handle error, e.g., show a notification
          error(data.message || "Failed to add item")
        }
      }
    )
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <>
        <ModalCloseButton handleClose={handleClose} />
        <Box className={styles.modal_container}>
          <AddItemForm onCancel={handleClose} onSubmit={handleAddItem} />
        </Box>
        <AlertError />
      </>
    </Modal>
  )
})

export default AddMarketItemModal
